import { BottomAlignIcon, RightAlignIcon } from 'canoe';
import React from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  justifyContent?: string;
  flexDirection?: string;
  toggleValues: (values: Record<string, unknown>) => void;
}

export const JustifyFlexEnd = ({ justifyContent, flexDirection, toggleValues }: Props) => {
  return (
    <ValueToggle
      toggleGroup="flex-justify"
      id="justify-flex-end"
      data-cy="toolbox-flex-justify-end"
      onClick={() =>
        toggleValues({
          justifyContent: 'flex-end',
        })
      }
      isActive={justifyContent === 'flex-end'}
      icon={flexDirection === 'row' ? RightAlignIcon : BottomAlignIcon}
      tooltip="End"
      color="light"
    />
  );
};
